<template>
    <!-- <p>Variation</p> -->
    <div class="bo-product-matrix" :class="{ 'is-popup': isPopup }">
        <div class="matrix-header">
            <div
                class="popup-wrapper"
                v-if="isPopup"
            >
                <img
                    class="product-image"
                    :src="Object.values(product.images)[0].source_url_medium"
                    alt="Image"
                />
                <div class="product-info">
                    <span class="sku"> {{ product.sku }} </span>
                    {{ product.name }}
                </div>
            </div>
            <div
                class="popup-wrapper title"
                v-else
            >
                {{ productMatrixTranslations.variation ?? "Variation" }}
            </div>
            <div
                class="right-panel"
                v-if="isPopup"
            >
                <i
                    class="icon-close cursor-pointer"
                    @click="deactivate"
                ></i>
            </div>
        </div>
        <div
            class="bo-table matrix-table"
            :class="{ 'popup-table': isPopup }"
        >
            <table>
                <thead>
                    <tr>
                        <th
                            @click="setDir"
                            :key="column ? column.id : 'default'"
                            class="matrix-first-column"
                            :class="[
                                column ? column.type + '-header' : '',
                                {
                                    sorting: column ? column.orderable : false,
                                    sorting_asc: dir == 'asc',
                                    sorting_desc: dir == 'desc',
                                },
                            ]"
                        >
                            <div class="matrix-table-header">
                                <input
                                    class="matrix-input"
                                    :placeholder="productMatrixTranslations.search ?? 'Search'"
                                    v-model="searchRowOptions"
                                />
                                {{
                                    productMatrixTranslations.row_family.replace(":object", row.name) ??
                                    row.name.concat(" Family")
                                }}
                            </div>
                        </th>
                        <template v-for="attributeColumn in columnOptions">
                            <th>
                                <div class="matrix-table-header">
                                    {{ attributeColumn.name }}
                                </div>
                            </th>
                        </template>
                        <th>
                            <div class="matrix-table-header">
                                {{ productMatrixTranslations.total ?? "Total" }}
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="Object.keys(rearrangedRowOptions).length === 0">
                        <td
                            :colspan="columnOptions ? Object.keys(columnOptions).length + 2 : 2"
                            class="no-data"
                        >
                            <div class="no-result-found">
                                <bo-svg
                                    :svg-content="'/assets/graphics/img-no-data.svg'"
                                    :primary-color="primaryColor"
                                ></bo-svg>
                                <div class="title">
                                    {{ generalTranslations.no_results_found ?? "No results found" }}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <template v-for="attributeRow in rearrangedRowOptions">
                        <tr>
                            <td class="matrix-first-column">
                                {{ attributeRow.name }}
                            </td>
                            <template v-for="attributeColumn in columnOptions">
                                <td>
                                    <!-- {{ getProduct(attributeRow, attributeColumn) }} -->
                                    <div
                                        v-if="getProduct(attributeRow, attributeColumn)"
                                        class="variation-wrapper"
                                    >
                                        <div class="left-panel">
                                            <!-- image -->
                                            <div
                                                v-if="getProduct(attributeRow, attributeColumn).images && Object.keys(getProduct(attributeRow, attributeColumn).images).length > 0"
                                                class="image-container"
                                            >
                                                <!-- <img
                                                    :src="
                                                        Object.values(
                                                            getProduct(attributeRow, attributeColumn).images
                                                        )[0].source_url
                                                    "
                                                /> -->
                                                <bo-image-lightbox
                                                    :images="getProduct(attributeRow, attributeColumn).images"
                                                >
                                                </bo-image-lightbox>
                                            </div>
                                            <div class="variation-info">
                                                <!-- stock -->
                                                <div
                                                    v-if="
                                                        !productInventoryExists(
                                                            getProduct(attributeRow, attributeColumn).id
                                                        )
                                                    "
                                                    class="item-in-stock"
                                                    :class="
                                                        getStockClass(
                                                            getProduct(attributeRow, attributeColumn).id,
                                                            user_warehouse_inventories
                                                        )
                                                    "
                                                >
                                                    {{ noInventoryTextHandler() }}
                                                </div>
                                                <div
                                                    v-if="hasInventory"
                                                    class="item-in-stock"
                                                    :class="
                                                        getStockClass(
                                                            getProduct(attributeRow, attributeColumn).id,
                                                            user_warehouse_inventories
                                                        )
                                                    "
                                                >
                                                    {{
                                                        user_warehouse_inventories[
                                                            getProduct(attributeRow, attributeColumn).id
                                                        ]?.stock_balance
                                                    }}
                                                </div>
                                                <!-- price -->
                                                <div
                                                    v-if="canReadPrices"
                                                    class="item-price"
                                                >
                                                    <bo-cell-currency
                                                        v-if="
                                                            getProductSalesPrice(attributeRow, attributeColumn) ==
                                                            getProduct(attributeRow, attributeColumn).regular_price
                                                        "
                                                        :value="
                                                            roundToDecimal(
                                                                addOrRemoveTaxIfNeeded(
                                                                    getProduct(attributeRow, attributeColumn)
                                                                        .regular_price
                                                                )
                                                            )
                                                        "
                                                        :currency="currencySymbol"
                                                    >
                                                    </bo-cell-currency>
                                                    <div
                                                        v-else
                                                        class="price-wrapper"
                                                    >
                                                        <div class="discount-price">
                                                            <bo-cell-currency
                                                                :value="
                                                                    getProduct(attributeRow, attributeColumn)
                                                                        .regular_price
                                                                "
                                                                :currency="currencySymbol"
                                                            ></bo-cell-currency>
                                                            <div class="discount-text">
                                                                {{
                                                                    calculateDiscountPercentage(
                                                                        getProductSalesPrice(
                                                                            attributeRow,
                                                                            attributeColumn
                                                                        ),
                                                                        getProduct(attributeRow, attributeColumn)
                                                                            .regular_price
                                                                    ).toFixed(2)
                                                                }}
                                                                %
                                                            </div>
                                                        </div>
                                                        <div class="price-with-tag">
                                                            <bo-cell-currency
                                                                :value="
                                                                    getProductSalesPrice(attributeRow, attributeColumn)
                                                                "
                                                                :currency="currencySymbol"
                                                            ></bo-cell-currency>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right-panel">
                                            <!-- quantity -->
                                            <input
                                                class="matrix-input"
                                                :value="getProductQuantity(attributeRow, attributeColumn)"
                                                @input="setProductQuantity(attributeRow, attributeColumn, ...arguments)"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </template>
                            <td>
                                <div class="row-total">
                                    <bo-cell-currency
                                        v-if="canReadPrices"
                                        :value="getRowTotalPrice(attributeRow)"
                                        :currency="currencySymbol"
                                    ></bo-cell-currency>
                                    <div class="row-total-units">
                                        {{ getRowTotalQuantity(attributeRow) }}
                                        {{ productMatrixTranslations.units ?? "units" }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- <div
            class="matrix-footer"
            :class="{ 'popup-matrix': isPopup }"
        >
            <div class="total">
                <div class="total-item">
                    <span
                        v-html="
                            productMatrixTranslations.total_amount_items.replace(':amount', totalQuantity) ??
                            'Total <span class=\'bold-text\'>'.concat(totalQuantity, ' items </span>')
                        "
                    ></span>
                </div>
                <div class="total-item">
                    <span
                        v-html="
                            productMatrixTranslations.total_price
                                .replace(':currency_symbol', currencySymbol)
                                .replace(':price', totalPrice.toFixed(2)) ??
                            'Total <span class=\'bold-text\'>RM'.concat(totalPrice.toFixed(2), '</span>')
                        "
                    ></span>
                </div>
            </div>
            <div
                v-if="isPopup"
                class="btn-matrix"
                @click="addToCart"
            >
                {{ generalTranslations.confirm ?? "Confirm" }}
            </div>
        </div> -->
        <bo-confirmation ref="bo_confirmation"></bo-confirmation>
    </div>
</template>

<script>
import Vue from "vue";
import cartMixin from "@/v2/mixins/carts.js";
import warehouseInventoryMixin from "@/v2/mixins/warehouse-inventories.js";
import boDatatableMixin from "@/v2/mixins/bo-datatable.js";
import { priceVisibilityMixin } from "@/v2/mixins/price-visibility.js";
import { Prompt } from "@/v2/models/bo-confirmation.js";

Vue.component("bo-image-lightbox", require("@/v2/components/bo-image-lightbox.vue").default);
Vue.component("bo-confirmation", require("@/v2/components/bo-confirmation.vue").default);
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);

export default {
    mixins: [cartMixin, warehouseInventoryMixin, boDatatableMixin, priceVisibilityMixin],
    components: {},
    props: {
        product: {
            type: Object,
            default: () => {},
        },
        isPopup: {
            type: Boolean,
            default: false,
        },
        addToCartProp: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            row: null,
            column: null,
            rowOptions: null,
            columnOptions: null,
            variationProductMap: {},
            variationProductAttributeMap: {},
            productQuantity: {},
            user_warehouse_inventories: {},
            hasWarehouseInventories: false,
            isLoadingWarehouseInventories: true,
            dir: null,
            searchRowOptions: "",
            hasInventory: window.bo.hasInventory,
            generalTranslations: window.bo?.generalTranslations ?? {},
            productMatrixTranslations: window.bo?.productMatrixTranslations ?? {},
            currencySymbol: window.bo?.currencySymbol ?? "RM",
            primaryColor: window.bo_primary_color || "#594c45",
        };
    },
    computed: {
        rearrangedRowOptions() {
            if (this.dir == null) {
                return this.filteredRowOptions;
            } else {
                return Object.values(this.filteredRowOptions).sort(this.sortByRowOptionName);
            }
        },
        filteredRowOptions() {
            if (this.searchRowOptions == "") {
                return this.rowOptions;
            }
            let rowOptions = {};
            const regExp = new RegExp(this.searchRowOptions, "i");
            Object.keys(this.rowOptions).forEach((rowOptionKey) => {
                if (this.rowOptions[rowOptionKey].name.match(regExp)) {
                    this.$set(rowOptions, rowOptionKey, this.rowOptions[rowOptionKey]);
                }
            });
            return rowOptions;
        },
        totalQuantity() {
            return Object.values(this.productQuantity).reduce((a, b) => a + parseInt(b), 0);
        },
        totalPrice() {
            return Object.keys(this.productQuantity).reduce(
                (a, b) =>
                    a +
                    parseInt(this.productQuantity[b]) *
                        this.getProductSalesPriceByProduct(
                            this.variationProductMap[this.variationProductAttributeMap[b].row][
                                this.variationProductAttributeMap[b].column
                            ]
                        ),
                0
            );
        },
    },
    watch: {
        addToCartProp: function (n, o) {
            if (n) {
                this.addToCart();
            }
        },
    },
    mounted() {
        const column = this.product.bulk_variation_input.columns;
        const row = this.product.bulk_variation_input.rows;
        Object.values(this.product.attributes).forEach((attribute) => {
            if (attribute.slug === row) {
                this.row = attribute;
                this.rowOptions = attribute.options;
            }
            if (attribute.slug === column) {
                this.column = attribute;
                this.columnOptions = attribute.options;
            }
        });
        Object.values(this.product.variations).forEach((variation) => {
            if (!this.variationProductMap[variation.attributes_index_by_slug[this.row.name]]) {
                this.variationProductMap[variation.attributes_index_by_slug[this.row.name]] = {};
            }
            if (
                !this.variationProductMap[variation.attributes_index_by_slug[this.row.name]][
                    variation.attributes_index_by_slug[this.column.name]
                ]
            ) {
                this.variationProductMap[variation.attributes_index_by_slug[this.row.name]][
                    variation.attributes_index_by_slug[this.column.name]
                ] = {};
            }
            this.variationProductMap[variation.attributes_index_by_slug[this.row.name]][
                variation.attributes_index_by_slug[this.column.name]
            ] = variation;

            this.variationProductAttributeMap[variation.id] = {
                row: variation.attributes_index_by_slug[this.row.name],
                column: variation.attributes_index_by_slug[this.column.name],
            };
        });

        if (window.bo.currentUserWarehouseInventoriesUrl) {
            this.getCurrentUserWarehouseInventories(
                {
                    params: { product_id: this.product.id },
                },
                (warehouseInventories) => {
                    if (warehouseInventories && !this.advancedUomStockQuantity) {
                        warehouseInventories.forEach((warehouseInventory) => {
                            Object.keys(this.product.variations).forEach((variationId) => {
                                const variation = this.product.variations[variationId];
                                if (warehouseInventory.conv_rate_group != variation.conv_rate_group) {
                                    return;
                                }
                                if (variation.id == warehouseInventory.product_id) {
                                    return;
                                }

                                let stockBalance = this.getStockBalance(warehouseInventory, variation);

                                warehouseInventories.push({
                                    product_id: variation.id,
                                    stock_balance: stockBalance,
                                    balance: this.roundToDecimal(warehouseInventory.balance / variation.uom.conversion_rate),
                                    physical_balance: this.roundToDecimal(
                                        warehouseInventory.physical_balance / variation.uom.conversion_rate
                                    ),
                                });
                            });
                        });
                    }
                    this.boProcessRecords(this.user_warehouse_inventories, warehouseInventories, "product_id");
                    if (Object.keys(this.user_warehouse_inventories).length > 0) {
                        this.hasWarehouseInventories = true;
                    } else {
                        this.hasWarehouseInventories = false;
                        this.isLoadingWarehouseInventories = false;
                    }
                }
            );
        }
        this.reloadTradeAgreementPrice();
    },
    methods: {
        deactivate() {
            this.$emit("deactivate");
        },
        sortByRowOptionName(a, b) {
            if (this.dir == "asc") {
                return a.name - b.name;
            } else if (this.dir == "desc") {
                return b.name - a.name;
            }
        },
        setDir() {
            if (!this.dir || this.dir == "desc") {
                this.dir = "asc";
            } else {
                this.dir = "desc";
            }
        },
        getProduct(row, column) {
            if (
                this.variationProductMap[row.name] &&
                this.variationProductMap[row.name][column.name] &&
                this.variationProductMap[row.name][column.name]?.status == "publish"
            ) {
                return this.variationProductMap[row.name][column.name];
            }
            return null;
        },
        getProductSalesPrice(row, column) {
            return this.getProductSalesPriceByProduct(this.getProduct(row, column));
        },
        getProductSalesPriceByProduct(variation) {
            if (variation.sale_price) {
                return variation.sale_price;
            }
            return variation.regular_price;
        },
        getProductRegularPriceByProduct(variation) {
            return variation.regular_price;
        },
        getProductQuantity(row, column) {
            const variation = this.getProduct(row, column);
            if (variation) {
                if (this.productQuantity[variation.id]) {
                    return this.productQuantity[variation.id];
                }
            }
            return null;
        },
        getRowTotalQuantity(row) {
            return Object.values(this.columnOptions).reduce((total, column) => {
                const variation = this.getProduct(row, column);
                if (!variation || !this.productQuantity[variation.id]) {
                    return total;
                }
                return total + parseInt(this.productQuantity[variation.id]);
            }, 0);
        },
        getRowTotalPrice(row) {
            return Object.values(this.columnOptions).reduce((total, column) => {
                const variation = this.getProduct(row, column);
                if (!variation || !this.productQuantity[variation.id]) {
                    return total;
                }
                return (
                    total + parseInt(this.productQuantity[variation.id]) * this.getProductSalesPriceByProduct(variation)
                );
            }, 0);
        },
        setProductQuantity(row, column, value) {
            const variation = this.getProduct(row, column);
            if (value.target.value == "" || value.target.value == 0) {
                this.$delete(this.productQuantity, variation.id);
            } else {
                this.$set(this.productQuantity, variation.id, value.target.value);
            }
            if (window.bo.company) {
                this.reloadTradeAgreementPrice();
            }
            this.$emit("matrix_total", this.totalPrice);
        },
        reloadTradeAgreementPrice() {
            let payload = {
                customer_id: window.bo.company.id,
                line_items: this.getCartItemsData(),
            };

            this.getCartTradeAgreementPrice(window.bo.cartTradeAgreementUrl, payload, (tradeAgreementPrices) => {
                Object.keys(tradeAgreementPrices).forEach((variationId) => {
                    let variation =
                        this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                            this.variationProductAttributeMap[variationId].column
                        ];

                    variation.regular_price = tradeAgreementPrices[variationId].unit_price;
                    switch (tradeAgreementPrices[variationId].type) {
                        case "absolute":
                        case "complex":
                            variation.sale_price =
                                tradeAgreementPrices[variationId].unit_price -
                                Math.round(tradeAgreementPrices[variationId].discount_value * 100) / 100;
                            break;

                        case "percentage":
                            variation.sale_price =
                                (tradeAgreementPrices[variationId].unit_price *
                                    (100 - Math.round(tradeAgreementPrices[variationId].discount_value * 100) / 100)) /
                                100;
                            break;
                    }

                    this.$set(
                        this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                            this.variationProductAttributeMap[variationId].column
                        ],
                        variation.id,
                        variation
                    );
                });
                this.$emit("matrix_total", this.totalPrice);
            });
        },
        productInventoryExists(productId) {
            return this.user_warehouse_inventories[productId] == null ? false : true;
        },
        getCartItemsData() {
            let itemsData = [];
            Object.keys(this.product.variations).forEach((variationId) => {
                itemsData.push({
                    id: variationId,
                    product_id: variationId,
                    quantity: this.productQuantity[variationId] ?? 0,
                });
            });
            return itemsData;
        },
        addOrRemoveTaxIfNeeded(price) {
            if (window.bo.taxExempted) {
                if (window.bo.taxIncluded && this.product.tax_class) {
                    return price / (1 + this.product.tax_class.percentage / 100);
                } else {
                    return price;
                }
            } else {
                if (
                    !this.product.tax_class ||
                    window.bo.taxIncluded == window.bo.displayPricesDuringCartAndCheckoutIncludingTax
                ) {
                    return price;
                } else if (window.bo.taxIncluded && !window.bo.displayPricesDuringCartAndCheckoutIncludingTax) {
                    return price / (1 + this.product.tax_class.percentage / 100);
                } else {
                    return price * (1 + this.product.tax_class.percentage / 100);
                }
            }
        },
        removeTaxIfNeeded(price) {
            if (
                (this.product.tax_class && window.bo.taxIncluded) ||
                (this.product.tax_class && window.bo.taxIncluded && window.bo.taxExempted)
            ) {
                return price / (1 + this.product.tax_class.percentage / 100);
            }
            return price;
        },
        roundToDecimal(number, decimal = 2) {
            var formattedResult = parseFloat(number.toFixed(decimal));
            return formattedResult;
        },
        getTax(price) {
            if (!this.product.tax_class || window.bo.taxExempted) {
                return 0;
            }
            if (window.bo.taxIncluded) {
                return (
                    (this.product.tax_class.percentage / 100) * (price / (1 + this.product.tax_class.percentage / 100))
                );
            } else {
                return price * (this.product.tax_class.percentage / 100);
            }
        },
        calculateDiscountPercentage(price, originalPrice) {
            return -(1 - price / originalPrice) * 100;
        },
        // inventory
        // If for the product has no inventory, handling based different user capabilities
        noInventoryTextHandler() {
            if (!window.bo.hasWarehouse) return "";
            if (window.bo.hasCapabilityPhysical) return window.bo?.productMatrixTranslations?.physical ?? "0s / 0p";
            if (window.bo.hasCapabilitySellable) return window.bo?.productMatrixTranslations?.sellable ?? "0 in Stock";
            if (window.bo.hasCapabilityRoughSellable) return window.bo.roughStockText;
            return window.bo?.productMatrixTranslations?.out_of_stock ?? "Out of stock";
        },
        getStockClass(productId, user_warehouse_inventories) {
            if (user_warehouse_inventories[productId] == null) return "danger";

            const stockBalance = user_warehouse_inventories[productId]?.stock_balance;
            const balance = user_warehouse_inventories[productId]?.balance;
            const physicalBalance = user_warehouse_inventories[productId]?.physical_balance;

            switch (true) {
                case stockBalance == "Out of Stock" || stockBalance.includes("Less than"):
                    return "danger";
                case balance <= 0 && physicalBalance <= 0:
                    return "danger";
                case balance <= 0 && physicalBalance > 0:
                    return "warning";
                case balance > 0 && physicalBalance <= 0:
                    return "warning";
                case balance > 0 && physicalBalance > 0:
                    return "success";
                default:
                    return "";
            }
        },
        addToCart() {
            if (this.product) {
                if (Object.keys(this.productQuantity).length > 0) {
                    const prompt = new Prompt(
                        () => {
                            this.postAddToCart(
                                window.bo.cartUrl,
                                this.addToCartPayload(),
                                //Save product...
                                () => {
                                    alert("Added product to cart.");
                                    this.$emit("added_to_cart_or_error", true);
                                },
                                (error) => {
                                    if (error.response.data.code == "prevent_adding_to_cart_error_rough_sellable") {
                                        alert(
                                            window.bo?.productMatrixTranslations?.product_insufficient_stock ??
                                                `The selected product cannot be added to your cart due to insufficient stock`
                                        );
                                        this.$emit("added_to_cart_or_error", true);
                                    } else {
                                        alert(
                                            window.bo?.productMatrixTranslations?.product_add_to_cart_error ??
                                                "Error adding product to the cart."
                                        );
                                        this.$emit("added_to_cart_or_error", true);
                                    }
                                }
                            );
                        },
                        null,
                        window.bo?.productMatrixTranslations?.change_selected_outlet ?? "Change Selected Outlet",
                        window.bo?.productMatrixTranslations?.change_selected_outlet_confirmation ??
                            "You are about to add items from a different outlet into your cart. This will change your selected outlet. Proceed?",
                        window.bo?.generalTranslations?.proceed ?? "Proceed",
                        "warning"
                    );

                    const toPrompt = window.bo.cartOutletId && window.bo.cartOutletId !== window.bo.outletId;
                    this.boPromptIfNeeded(prompt, toPrompt);
                } else {
                    alert(window.bo?.productMatrixTranslations?.no_product_to_add_error ?? "No product to add to cart");
                    this.$emit("added_to_cart_or_error", true);
                }
            } else {
                this.$emit("added_to_cart_or_error", true);
            }
        },
        addToCartPayload() {
            let cartItems = [];
            Object.keys(this.productQuantity).forEach((variationId) => {
                cartItems.push({
                    product_id: variationId,
                    component_id: null,
                    quantity: this.productQuantity[variationId],
                    subtotal: this.roundToDecimal(
                        this.removeTaxIfNeeded(
                            this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                                this.variationProductAttributeMap[variationId].column
                            ]
                        ).regular_price * this.productQuantity[variationId]
                    ),
                    subtotal_tax: this.getTax(
                        this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                            this.variationProductAttributeMap[variationId].column
                        ].regular_price * this.productQuantity[variationId]
                    ),
                    total: this.roundToDecimal(
                        this.removeTaxIfNeeded(
                            this.getProductSalesPriceByProduct(
                                this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                                    this.variationProductAttributeMap[variationId].column
                                ]
                            )
                        ) * this.productQuantity[variationId]
                    ),
                    total_tax: this.getTax(
                        this.getProductSalesPriceByProduct(
                            this.variationProductMap[this.variationProductAttributeMap[variationId].row][
                                this.variationProductAttributeMap[variationId].column
                            ]
                        ) * this.productQuantity[variationId]
                    ),
                });
            });
            return {
                id: window.bo.cartId,
                outlet: window.bo.outletId,
                items: cartItems,
            };
        },
        getStockBalance(warehouseInventory, variation) {
            if (window.bo.hasCapabilityPhysical) {
                let sellable = this.roundToDecimal(warehouseInventory.balance / variation.uom.conversion_rate);
                let physical = this.roundToDecimal(warehouseInventory.physical_balance / variation.uom.conversion_rate);
                return sellable + "s / " + physical + "p";
            }
            if (window.bo.hasCapabilitySellable) {
                return this.roundToDecimal(warehouseInventory.balance / variation.uom.conversion_rate) + "in Stock";
            }
            if (window.bo.hasCapabilityRoughSellable) return window.bo.roughStockText;
            if (warehouseInventory.balance > 0) return "In Stock";
            return "Out of stock";
        },
    },
};
</script>
